import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getClinicPackage } from '../../../../store/slices/packageMaster.slice';
import { useSelector, useDispatch } from "react-redux";
import { getAllPhysician } from "../../../../store/slices/physicianSlice";

const HealthPackages = ({ handleChange, isClient }) => {
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const { clinicPackageMaster } = useSelector((state) => state.packageMaster);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const { physician } = useSelector((state) => state.physician);
  const dispatch = useDispatch();
const clinicId =clinicInfo?.[0]?.clinicId ||null;
  useEffect(() => {
    dispatch(getClinicPackage({ clinicId, token }));
  }, [dispatch, clinicId, token]);

  useEffect(() => {
    dispatch(getAllPhysician({ clinicId, clinicStatus: "Accepted", physicianStatus: "Accepted", token }));
  }, [dispatch, token, clinicId]);

  useEffect(() => {
    const total = selectedOptions?.reduce((sum, option) => {
      const selectedService = clinicPackageMaster?.find(
        (service) => service?._id === option.value
      );
      if (!selectedService) return sum;
      if (isClient === "Yes" && selectedService?.clientPrice != null) {
        return sum + selectedService?.clientPrice;
      } else if (selectedService?.pt_price != null) {
        return sum + selectedService?.pt_price;
      }
      return sum;
    }, 0);
    setTotalAmount(total);
  }, [isClient, selectedOptions, clinicPackageMaster]);

  const handleSelectedHealthPackageService = (options) => {
    setSelectedOptions(options || []);
    handleChange(
      (options || []).map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails"
    );
  };

  return (
    <>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Service Details:
          </label>
          <Select
            options={
              clinicPackageMaster &&
              clinicPackageMaster?.map((packages) => ({
                value: packages._id,
                label: packages?.packageName,
                type: 'healthPackages',
                price: isClient === "Yes" ? packages?.clientPrice : packages?.pt_price,
              }))
            }
            isMulti
            value = {selectedOptions}
            onChange={handleSelectedHealthPackageService}
            styles={{
              container: (provided) => ({ ...provided, marginTop: 8 }),
            }}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Consulting Physician:
          </label>
          <Select
            options={
              physician &&
              physician?.map((physician) => ({
                value: physician?._id,
                label: physician?.userId?.name,
              }))
            }
            onChange={(e) => handleChange(e, "physician")}
            styles={{
              container: (provided) => ({ ...provided, marginTop: 8 }),
            }}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="total-amount" className="col-form-label">
            Total Amount:
          </label>
          <input
            type="number"
            className="form-control"
            id="total-amount"
            value={totalAmount}
            readOnly
          />
        </div>
      </div>
    </>
  );
};

export default HealthPackages;